export const COMPONENT_NAME = "ui-input";
